module.exports = __webpack_public_path__ + "static/img/shopHeaderBg1080.b442fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopHeaderBg1080.png
// module id = VZrA
// module chunks = 18